import Vue, { CreateElement, RenderContext, VNode, VNodeData } from "vue";
import CheckAuthorities from "@scrile/tools/vue/components/CheckAuthorities";

interface Props {
  requiredAuthorities: string[];
  tag: string;
}

export default Vue.extend({
  name: "CheckAuthorities",
  functional: true,
  props: {
    requiredAuthorities: { type: Array, required: true },
    tag: { type: String, default: "div" },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    let data: VNodeData = {
      ...ctx.data,
      props: {
        currentAuthorities: ctx.parent.$store.state.authorities || [],
        ...ctx.props,
      },
      on: ctx.listeners,
    };
    return h(CheckAuthorities, data, [ctx.scopedSlots.default && ctx.scopedSlots.default({})]);
  },
});
